export default class PlayerConfig {
  width?: string = '100%'
  height?: string = '100%'
  muted?: boolean
  controls?: boolean
  autoplay?: 'auto'
  preload?: 'load'
  poster?: string
  duration?: number
  currentTime: number
  src?: string
  // 倍速播放按钮
  playbackRates?: Array<number> = []
}
